import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";
import { IBrandOrganisation } from "@shared/lib/types/brandOrganisation";
import { ORGANISATION_LIST_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export default function useDeleteNotificationRecipients() {
  const {
    mutate: deleteNotificationRecipients,
    isLoading: isDeleteNotificationRecipientsLoading,
    isSuccess: isDeleteNotificationRecipientsSuccess,
    error: deleteNotificationRecipientsError,
  } = useMutation({
    mutationFn: (payload: {
      brandOrganisationId: string;
      notificationReciepentsId: string;
    }) => OrganisationService.deleteNotificationRecipient(payload),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, params) => {
      c.setQueryData(
        [...ORGANISATION_LIST_QUERY_KEY, params.brandOrganisationId],
        (oldData: BackednResponse<IBrandOrganisation>) => ({
          ...oldData,
          data: {
            ...oldData?.data,
            adRightsSettings: {
              ...oldData?.data?.adRightsSettings,
              alertNotificationReciepents: [
                ...data.data?.adRightsSettings?.alertNotificationReciepents,
              ],
            },
          },
        })
      );
    },
  });

  return {
    deleteNotificationRecipients,
    isDeleteNotificationRecipientsLoading,
    deleteNotificationRecipientsError,
    isDeleteNotificationRecipientsSuccess,
  };
}
